import { useEffect, useRef } from 'react';

// Belt-and-suspenders ringtone: Streams' own softphone ringtone (disableRingtone:false
// in ContactContext) plays inside the hidden CCP iframe, which should still be audible,
// but audio inside a display:none iframe is a known trouble spot in some browsers. This
// generates a simple two-tone ring directly in the page via Web Audio — no assets, no deps.
export function useRingtone(active) {
  const ctxRef = useRef(null);
  const timerRef = useRef(null);

  useEffect(() => {
    if (!active) return undefined;
    // Demo mode (row 234, &screen=ringing): the ring screen is for looking at, silently.
    if (isDemoPage()) return undefined;

    const AudioCtx = window.AudioContext || window.webkitAudioContext;
    if (!AudioCtx) return undefined;
    const ctx = new AudioCtx();
    ctxRef.current = ctx;

    function ring() {
      const now = ctx.currentTime;
      [0, 0.35].forEach(offset => {
        const osc = ctx.createOscillator();
        const gain = ctx.createGain();
        osc.type = 'sine';
        osc.frequency.value = 440;
        gain.gain.setValueAtTime(0, now + offset);
        gain.gain.linearRampToValueAtTime(0.15, now + offset + 0.02);
        gain.gain.linearRampToValueAtTime(0, now + offset + 0.3);
        osc.connect(gain).connect(ctx.destination);
        osc.start(now + offset);
        osc.stop(now + offset + 0.32);
      });
    }

    ring();
    timerRef.current = setInterval(ring, 2000);

    return () => {
      clearInterval(timerRef.current);
      ctx.close().catch(() => {});
    };
  }, [active]);
}

function isDemoPage() {
  try { return new URLSearchParams(window.location.search).has('demo'); } catch { return false; }
}
